import { Controller } from '@hotwired/stimulus'
import parsePhoneNumber from 'libphonenumber-js/max'
import { getDiagnoseFacilities } from '../api/common/diagnose_facilities'
import delay from 'lodash/delay'

const DELAY_TIME = 800

export default class extends Controller {
  static targets = [
    'main',
    'form',
    'question',
    'chatInputModalNextButton',
    'prefectures',
    'prefecture',
    'cities',
    'city',
    'telInput',
    'telError',
    'footer',
    'submit',
    'text',
    'modal',
    'areaValues',
    'currentStatusText',
    'prefectureText',
    'cityText',
    'timeText',
    'diagnoseCountText',
    'resultQuestionA',
    'resultQuestionB',
    'tel',
    'normalQuestion',
    'skipQuestion',
    'step17normalQuestion',
    'step17fullQuestion',
    'leaveModal',
  ]

  static values = {
    abCategory: String,
    startTime: Number,
    finishTime: Number,
  }

  static classes = [
    'displayVisible',
    'displayHidden',
    'visibilityVisible',
    'visibilityHidden',
    'valid',
    'invalid',
  ]

  get controllerName () {
    return this.element.dataset.controller
  }

  get className () {
    return this.element.dataset.classname
  }

  connect () {
    // デバッグ用
    this.isDevelop = false

    window.addEventListener('beforeunload', this.openUnloadDialog)

    // 流入時刻を取得
    if (this.abCategoryValue === 'B' && !this.hasStartTimeValue) {
      this.startTimeValue = (new Date()).getTime()
    }

    // コラムCTAから入力値を引き継ぐ場合は、入力をスキップして5からはじめる
    const url = new URL(window.location.href)
    const params = url.searchParams

    if (params.has('occupant_current_status_id') && params.has('occupant_timing_id') && params.has('occupant_gender') && params.has('occupant_age')) {
      const currentStatus = this.formTarget.elements['inquiry[occupant_current_status_id]']
      const gender = this.formTarget.elements['inquiry[occupant_gender]']
      const age = this.formTarget.elements['inquiry[occupant_age]']
      const timing = this.formTarget.elements['inquiry[occupant_timing_id]']
      const careLevel = this.formTarget.elements['inquiry[occupant_care_level_id]']

      currentStatus.value = params.get('occupant_current_status_id')
      gender.value = params.get('occupant_gender')
      timing.value = params.get('occupant_timing_id')

      const ageValue = Math.floor(params.get('occupant_age') / 10) * 10
      if (ageValue >= 60 && ageValue <= 90) {
        age.value = ageValue
      } else {
        age.value = -1
      }

      if (params.get('occupant_care_level')) {
        careLevel.value = params.get('occupant_care_level')
        // targetsの配列をコピーしてからremoveを実行
        Array.from(this.normalQuestionTargets).forEach(elm => {
          elm.remove()
        })
        this.showNextChat(5)
      } else {
        // 要素が存在する場合のみremoveを実行
        this.normalQuestionTargets[0]?.remove()
        this.skipQuestionTargets[1]?.remove()
        this.showNextChat(4)
      }
    } else {
      // targetsの配列をコピーしてからremoveを実行
      Array.from(this.skipQuestionTargets).forEach(elm => {
        elm.remove()
      })

      this.showNextChat(1)
    }
  }

  setTime () {
    if (!this.hasFinishTime) {
      this.finishTimeValue = (new Date()).getTime()
      console.log(this.finishTimeValue)
    }
    const diffTime = this.finishTimeValue - this.startTimeValue
    const minutes = Math.floor(diffTime / (1000 * 60))
    const seconds = Math.floor((diffTime % (1000 * 60)) / 1000)

    if (minutes && seconds) {
      if (this.hasTimeTextTarget) {
        this.timeTextTargets.forEach(target => {
          target.innerHTML = `現在回答を始めてから${minutes}分${seconds}秒が経過しましたが、残り1項目です。`
        })
      }
    } else {
      if (this.hasTimeTextTarget) {
        this.timeTextTargets.forEach(target => {
          target.innerHTML = '現在回答を始めてから約5分が経過しましたが、残り1項目です。'
        })
      }
    }
  }

  openUnloadDialog (e) {
    e.preventDefault()
    e.returnValue = ''
  }

  openLeaveModal () {
    if (!this.isDevelop) {
      this.closeLeaveModal()
      this.leaveModalTarget.classList.remove(this.displayHiddenClass)
      const chatQuestionContainer = document.getElementById('chat_question_container_leave')
      const loader1 = document.getElementById('chat_loader_leave_1')
      const loader2 = document.getElementById('chat_loader_leave_2')
      const chatQuestion1 = document.getElementById('chat_question_leave_1')
      const chatQuestion2 = document.getElementById('chat_question_leave_2')

      delay(() => {
        chatQuestionContainer.classList.add(this.visibilityVisibleClass)
      }, 800)
      delay(() => {
        loader1.classList.add(this.displayHiddenClass)
        chatQuestion1.classList.add(this.displayVisibleClass)
      }, 1600)
      delay(() => {
        loader2.classList.remove(this.displayHiddenClass)
      }, 2400)
      delay(() => {
        loader2.classList.add(this.displayHiddenClass)
        chatQuestion2.classList.add(this.displayVisibleClass)
      }, 3200)
    } else {
      console.log('open modal')
    }
  }

  closeLeaveModal () {
    this.leaveModalTarget.classList.add(this.displayHiddenClass)
    const chatQuestionContainer = document.getElementById('chat_question_container_leave')
    const loader1 = document.getElementById('chat_loader_leave_1')
    const loader2 = document.getElementById('chat_loader_leave_2')
    const chatQuestion1 = document.getElementById('chat_question_leave_1')
    const chatQuestion2 = document.getElementById('chat_question_leave_2')
    chatQuestionContainer.classList.remove(this.visibilityVisibleClass)
    loader1.classList.remove(this.displayHiddenClass)
    chatQuestion1.classList.remove(this.displayVisibleClass)
    loader2.classList.add(this.displayHiddenClass)
    chatQuestion2.classList.remove(this.displayVisibleClass)
  }

  hideCurrentChatInput (e, text) {
    const title = e.currentTarget.dataset.title
    const current = e.currentTarget.dataset.current
    const currentInput = document.getElementById(`chat_input_${current}`)
    currentInput.classList.add(this.displayHiddenClass)

    delay(() => {
      currentInput.insertAdjacentHTML('beforebegin', `
        <div class="${this.element.dataset.classname}::chat-answer-container">
        <div class="${this.element.dataset.classname}::chat-answer-read">既読</div>
        <div class="${this.element.dataset.classname}::chat-answer">${text || title}</div>
        </div>
      `)
    }, DELAY_TIME / 2)
  }

  showNextChat (step, delayTime) {
    const chatQuestionContainer = document.getElementById(`chat_question_container_${step}`)
    const chatInput = document.getElementById(`chat_input_${step}`)
    const loaders = chatQuestionContainer.getElementsByClassName(`${this.className}::loader`)
    const chatQuestions = chatQuestionContainer.getElementsByClassName(`${this.className}::chat-question`)
    const nextDom = this.questionTargets[step - 1]

    this.questionTargets[step - 1].style.display = 'block'
    delay(() => {
      chatQuestionContainer.classList.add(this.visibilityVisibleClass)
    }, DELAY_TIME)
    Array.from(chatQuestions).forEach((elm, index) => {
      delay(() => {
        loaders[index].classList.add(this.displayHiddenClass)
      }, DELAY_TIME * (index + 2) - 400)
      delay(() => {
        chatQuestions[index].classList.add(this.displayVisibleClass)
      }, DELAY_TIME * (index + 2))
      delay(() => {
        window.scroll({ top: nextDom.offsetTop, left: 0, behavior: 'smooth' })
      }, DELAY_TIME * (index + 2))
    })
    if (delayTime) {
      delay(() => {
        chatInput.classList.add(this.visibilityVisibleClass)
      }, delayTime)
      delay(() => {
        window.scroll({ top: nextDom.offsetTop, left: 0, behavior: 'smooth' })
      }, delayTime + 400)
    } else {
      delay(() => {
        chatInput.classList.add(this.visibilityVisibleClass)
      }, DELAY_TIME * (chatQuestions.length + 2))
    }

    console.log(`next:${step}`)
  }

  appendChatInputs (step) {
    const template = document.getElementById(`chat_template_${step}`)
    const clone = template.content.cloneNode(true)
    document.getElementById(`chat_append_${step}`).appendChild(clone)
  }

  nextChatWithScroll (e) {
    this.hideCurrentChatInput(e)
    this.showNextChat(e.currentTarget.dataset.next)
  }

  nextChatWithScrollReductionSystem (e) {
    console.log(e.target.value)
    if (e.target.value === '1') {
      // 要素が存在する場合のみremoveを実行
      this.step17normalQuestionTarget?.remove()
    } else {
      // 要素が存在する場合のみremoveを実行
      this.step17fullQuestionTarget?.remove()
    }
    this.hideCurrentChatInput(e)
    this.showNextChat(e.currentTarget.dataset.next)
  }

  nextChatWithScrollChoseCurrentStatus (e) {
    if (this.hasCurrentStatusTextTarget) {
      this.currentStatusTextTarget.innerHTML = e.target.dataset.title
    }
    this.hideCurrentChatInput(e)
    this.showNextChat(e.currentTarget.dataset.next)
  }

  skipChatWithScroll (e) {
    this.hideCurrentChatInput(e)
    this.showNextChat(Number(e.currentTarget.dataset.next) + 1)
  }

  nextChatWithScrollCheckAnswer (e) {
    const currentStatusValue = this.formTarget.elements['inquiry[occupant_medical_care_required_id]'].value
    this.hideCurrentChatInput(e)

    if (currentStatusValue === '1') {
      this.showNextChat(e.currentTarget.dataset.next)
    } else {
      this.showNextChat(Number(e.currentTarget.dataset.next) + 1)
    }
  }

  chatInputModalNextButtonStatus (e) {
    const checkedFlag = Array.from(this.formTarget.elements['inquiry[medical_care_types][]']).some(function (checkbox) {
      return checkbox.checked
    })
    this.chatInputModalNextButtonTarget.disabled = !checkedFlag
  }

  nextChatForMedicalCare (e) {
    // 必要な医療ケア
    const medicalCareTypesValues = []
    const medicalCareTypesNames = []

    this.formTarget.elements['inquiry[medical_care_types][]'].forEach(elm => {
      if (elm.checked) {
        medicalCareTypesValues.push(elm.value)
        medicalCareTypesNames.push(elm.dataset.title)
      }
    })

    const valueText = medicalCareTypesNames.length > 0 ? medicalCareTypesNames.join('、') : 'ありません'

    this.hideCurrentChatInput(e, valueText)

    this.showNextChat(e.currentTarget.dataset.next)
  }

  nextChatChoseOccupantTiming (e) {
    // こだわり条件
    const specialFeatureValues = []
    const specialFeatureNames = []

    this.formTarget.elements['inquiry[special_feature_names][]'].forEach(elm => {
      if (elm.checked) {
        specialFeatureValues.push(elm.value)
        specialFeatureNames.push(elm.dataset.title)
      }
    })

    const valueText = specialFeatureNames.length > 0 ? specialFeatureNames.join('、') : 'ありません'

    this.hideCurrentChatInput(e, valueText)

    if (this.formTarget.elements['inquiry[occupant_timing_id]'].value !== '') {
      this.showNextChat(Number(e.currentTarget.dataset.next) + 1)
    } else {
      this.showNextChat(e.currentTarget.dataset.next)
    }
  }

  nextChatPrefectures (e) {
    const regionId = e.target.value
    const nextStep = e.currentTarget.dataset.next
    this.hideCurrentChatInput(e)
    fetch(`/area/regions/${regionId}/prefectures.json`)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP Error: ${response.status}`)
        return response.json()
      })
      .then(prefectures => {
        this.updatePrefectures(prefectures)
        this.showNextChat(nextStep)
      })
      .catch(error => {
        if (typeof Sentry !== 'undefined') {
          Sentry.captureException(error, { tags: { component: 'inquiry-chat-column-two', operation: 'fetch-prefectures' } })
        }
        console.error('Failed to fetch prefectures:', error)
      })
  }

  nextChatChoseCity (e) {
    this.modalTarget.classList.add(this.displayHiddenClass)
    if (this.hasCityTextTarget) {
      this.cityTextTargets.forEach(target => {
        target.innerHTML = e.target.dataset.city
      })
    }
    this.hideCurrentChatInput(e, `${this.prefectureTarget.innerHTML}${e.target.dataset.title}`)
    this.showNextChat(e.currentTarget.dataset.next)
  }

  nextChatWithSubmitBefore2 (e) {
    this.submitTarget.innerHTML = '残り2項目です'
    this.hideCurrentChatInput(e)
    this.showNextChat(e.currentTarget.dataset.next)
    this.nextChatWithSubmit(e)
  }

  nextChatWithSubmitBefore1 (e) {
    this.submitTarget.innerHTML = '残り1項目です'
    this.hideCurrentChatInput(e)

    const step = Number(this.telTarget.dataset.step)
    this.appendChatInputs(step)
    this.showNextChat(step)
    this.nextChatWithSubmit(e)
  }

  nextChatWithSubmit (e) {
    this.footerTarget.classList.add(this.displayVisibleClass)
    delay(() => {
      window.scroll({
        top: this.footerTarget.offsetTop + this.footerTarget.clientHeight - window.innerHeight,
        left: 0,
        behavior: 'smooth',
      })
    }, 800)
  }

  submitForm () {
    window.removeEventListener('beforeunload', this.openUnloadDialog)
  }

  showCitiesModal (e) {
    const prefectureId = e.target.value
    this.prefectureTarget.innerHTML = e.target.dataset.title
    if (this.hasPrefectureTextTarget) {
      this.prefectureTextTargets.forEach(target => {
        target.innerHTML = e.target.dataset.title
      })
    }
    this.modalTarget.classList.remove(this.displayHiddenClass)
    fetch(`/area/prefectures/${prefectureId}/cities.json`)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP Error: ${response.status}`)
        return response.json()
      })
      .then(cities => this.updateCities(e, cities))
      .catch(error => {
        if (typeof Sentry !== 'undefined') {
          Sentry.captureException(error, { tags: { component: 'inquiry-chat-column-two', operation: 'fetch-cities' } })
        }
        console.error('Failed to fetch cities:', error)
      })
  }

  openText () {
    this.textTarget.classList.remove(this.displayHiddenClass)
  }

  closeText () {
    this.textTarget.classList.add(this.displayHiddenClass)
  }

  getDiagnoseFacilityParams () {
    let params = {}
    let careLevelId = null
    let monthlyFeeMin = null
    let monthlyFeeMax = null
    let welfareAcceptable = null
    let dementiaAcceptable = null
    let diabetes = false
    const specialFeatureValues = []
    const medicalCareTypesValues = []

    // 入居希望者の介護度
    if (this.formTarget.elements['inquiry[occupant_care_level_id]'] &&
      Number(this.formTarget.elements['inquiry[occupant_care_level_id]'].value) >= 0 &&
      this.formTarget.elements['inquiry[occupant_care_level_id]'].value !== '30') {
      careLevelId = this.formTarget.elements['inquiry[occupant_care_level_id]'].value
    }

    // 月額予算
    switch (this.formTarget.elements['inquiry[expected_monthly_fee_id]'].value) {
      case '1':
        monthlyFeeMin = null
        monthlyFeeMax = 149999
        break
      case '2':
        monthlyFeeMin = 150000
        monthlyFeeMax = 199999
        break
      case '3':
        monthlyFeeMin = 200000
        monthlyFeeMax = 249999
        break
      case '4':
        monthlyFeeMin = 250000
        monthlyFeeMax = 299999
        break
      case '5':
        monthlyFeeMin = 300000
        monthlyFeeMax = null
        break
      default:
        monthlyFeeMin = null
        monthlyFeeMax = null
        break
    }

    // 必要な医療ケア
    this.formTarget.elements['inquiry[medical_care_types][]'].forEach(elm => {
      if (elm.checked) {
        medicalCareTypesValues.push(elm.value)
      }
    })

    // こだわり条件
    this.formTarget.elements['inquiry[special_feature_names][]'].forEach(elm => {
      if (elm.checked) {
        specialFeatureValues.push(elm.value)
      }
    })

    // 認知症の症状
    if (this.formTarget.elements['inquiry[occupant_dementia_id]'] &&
      this.formTarget.elements['inquiry[occupant_dementia_id]'].value === '1') {
      dementiaAcceptable = this.formTarget.elements['inquiry[occupant_dementia_id]'].value
    }

    // 糖尿病の症状
    if (this.formTarget.elements['inquiry[occupant_diabetes]'] &&
      this.formTarget.elements['inquiry[occupant_diabetes]'].value === '1') {
      diabetes = true
    }

    // 生活保護の受給状況
    if (this.formTarget.elements['inquiry[occupant_social_security_status_id]'] &&
      this.formTarget.elements['inquiry[occupant_social_security_status_id]'].value === '1') {
      welfareAcceptable = this.formTarget.elements['inquiry[occupant_social_security_status_id]'].value
    }

    // こだわり条件の「認知症相談可」が選択されている場合は認知症の症状を「あり」に設定
    if (specialFeatureValues.includes('ninchisyo')) {
      dementiaAcceptable = '1'
    }

    // こだわり条件の「生活保護相談可」が選択されている場合は生活保護の受給状況を「あり」に設定
    if (specialFeatureValues.includes('seikatuhogo')) {
      welfareAcceptable = '1'
    }

    params = {
      prefecture_id: this.formTarget.elements['inquiry[prefecture_id]'] ? this.formTarget.elements['inquiry[prefecture_id]'].value : null,
      city_ids: this.formTarget.elements['inquiry[city_id]'] ? [this.formTarget.elements['inquiry[city_id]'].value] : null,
      monthly_fee_min: monthlyFeeMin,
      monthly_fee_max: monthlyFeeMax,
      welfare_acceptable: welfareAcceptable,
      dementia_acceptable: dementiaAcceptable,
      medical_care_id: diabetes ? '201' : null,
      care_level_id: careLevelId,
      special_features: specialFeatureValues,
      medical_care_types: medicalCareTypesValues,
    }

    return params
  }

  diagnoseFacilities () {
    const specialFeatureTexts = []

    this.formTarget.elements['inquiry[special_feature_names][]'].forEach(elm => {
      if (elm.checked) {
        specialFeatureTexts.push(elm.dataset.title)
      }
    })

    getDiagnoseFacilities(this.getDiagnoseFacilityParams()).then((data) => {
      console.log('diagnose success')
      console.log(data.results.length)
      if (data.results.length > 0) {
        // 診断結果が1件以上の場合
        if (this.hasResultQuestionBTarget) {
          this.resultQuestionBTarget.style.display = 'block'
        }
        if (this.hasDiagnoseCountTextTarget) {
          this.diagnoseCountTextTargets.forEach(target => {
            target.innerHTML = data.results.length
          })
        }
      } else {
        // 診断結果が0件の場合
        this.retryDiagnoseFacilities()
      }
    })
  }

  retryDiagnoseFacilities () {
    let paramsArea = {}
    let paramsFee = {}

    // 「エリアを広げる」の場合
    // 市区町村を設定しない
    paramsArea = this.getDiagnoseFacilityParams()
    delete paramsArea.city_ids

    paramsFee = this.getDiagnoseFacilityParams()
    // 「予算を広げる」の場合
    // 予算設定を削除
    paramsFee.monthly_fee_min = null
    paramsFee.monthly_fee_max = null

    getDiagnoseFacilities(paramsArea).then((dataArea) => {
      console.log('diagnose(no-area) success')
      console.log(dataArea.results.length)

      getDiagnoseFacilities(paramsFee).then((dataFee) => {
        console.log('diagnose(no-fee) success')
        console.log(dataFee.results.length)
        const count = dataArea.results.length + dataFee.results.length

        if (count > 0) {
          // 診断結果が1件以上の場合
          if (this.hasResultQuestionBTarget) {
            this.resultQuestionBTarget.style.display = 'block'
          }
          this.diagnoseCountTextTargets.forEach(target => {
            target.innerHTML = count
          })
        } else {
          // 診断結果が0件の場合
          if (this.hasResultQuestionATarget) {
            this.resultQuestionATarget.style.display = 'block'
          }
          console.log('non result')
        }
      })
    })
  }

  updateCities (e, cities) {
    const current = e.target.dataset.current
    const next = e.target.dataset.next
    const action = this.citiesTarget.dataset.nextAction
    const gtagEvent = this.citiesTarget.dataset.gtag
    const gtmEfCategory = this.citiesTarget.dataset.gtmEfCategory
    const gtmEventName = this.citiesTarget.dataset.gtmEventName
    this.citiesTarget.innerHTML =
      cities.map((city) => (
        `
          <li>
            <label>
              <input
                type="radio"
                name="inquiry[city_id]"
                value="${city.id}"
                class="inquiry-step-button"
                data-gtm-ef-category="${gtmEfCategory}"
                data-gtm-event="${gtmEventName}"
                data-title="${city.name}です"
                data-city="${city.name}"
                data-action="${action}"
                data-current="${current}"
                data-next="${next}"
                onClick="${gtagEvent}"
              />
              ${city.name}
            </label>
          </li>
      `)).join('')
  }

  updatePrefectures (prefectures) {
    const current = this.prefecturesTarget.dataset.current
    const next = this.prefecturesTarget.dataset.next
    const action = this.prefecturesTarget.dataset.nextAction
    const gtagEvent = this.prefecturesTarget.dataset.gtag
    const gtmEfCategory = this.prefecturesTarget.dataset.gtmEfCategory
    const gtmEventName = this.prefecturesTarget.dataset.gtmEventName
    const className = this.prefecturesTarget.dataset.className
    this.prefecturesTarget.innerHTML =
      prefectures.map(prefecture => (
        `
          <label class="${className}">
            <input
              type="radio"
              name="inquiry[prefecture_id]"
              value="${prefecture.id}"
              class="inquiry-step-button"
              data-gtm-ef-category="${gtmEfCategory}"
              data-gtm-event="${gtmEventName}"
              data-title="${prefecture.name}"
              data-next="${next}"
              data-current="${current}"
              data-action="${action}"
              onClick="${gtagEvent}"
            />
            <span>${prefecture.name}</span>
          </label>
        `
      )).join('')
  }

  toggleTelAndSubmit (isValid, telNumber) {
    if (isValid) {
      this.telInputTarget.classList.remove(this.invalidClass)
      this.telInputTarget.classList.add(this.validClass)
      this.submitTarget.disabled = false
      this.submitTarget.innerHTML = '問い合わせ（無料）'
      this.telErrorTarget.style.display = 'none'
      document.getElementById('inquiry_is_sms_sendable_tel').value = this.isSmsSendableTel(telNumber).toString()
    } else {
      this.telInputTarget.classList.add(this.invalidClass)
      this.telInputTarget.classList.remove(this.validClass)
      this.telErrorTarget.style.display = 'flex'
    }
  }

  validatePhoneNumber () {
    const value = this.telInputTarget.value
    if (value) {
      const phoneNumber = parsePhoneNumber(value, 'JP')
      this.toggleTelAndSubmit(phoneNumber?.isValid(), value)
    }
  }

  isSmsSendableTel (rawPhoneNumber) {
    const regex = /^(070|080|090)/
    return regex.test(rawPhoneNumber)
  }
}
